import { Component, Vue, Watch, Ref } from 'vue-property-decorator';
import HeaderBar from '@/components/general/headerbar/HeaderBar.vue';
import TitleButton from '@/components/general/titlebutton/TitleButton.vue';
import QuickSelectMenu from '@/components/general/quickselectmenu/QuickSelectMenu';
import Section, { ISectionComponentMethods } from '@/components/edit/section/Section';
import EditComponent from '../edit/Edit';


@Component({
    components: {
        HeaderBar,
        Section,
        TitleButton,
        QuickSelectMenu,
    },
})

export default class PreviewComponent extends EditComponent {
    private goToDashboard: boolean = false;

    public onCloseClicked() {
        this.dialogCancel = this.$vuetify.lang.t('$vuetify.buttons.cancel');
        this.dialogOk = this.$vuetify.lang.t('$vuetify.buttons.ok');
        this.dialog = false;
        if (this.goToDashboard === true) {
            this.$router.replace({name: 'dashboard'});
        } else {
            this.$router.back();
        }
    }
}
